import parsePhoneNumberFromString from 'libphonenumber-js'

function isEmailReal(email: string) {
    if (email.length !== 0) {
        const re1 = /^[^\s@]+@ehpad\d{0,2}\.fr$/
        const re2 = /^[^\s@]+@toktokdoc\.me$/
        if (re1.test(email) === false && re2.test(email) === false) {
            return true
        }
        return false
    }
    return false
}

export { isEmailReal }

export const parsePhoneNumber = (phoneNumber: string | undefined) => {
    if (!phoneNumber) return undefined
    const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber, 'FR')

    if (parsedPhoneNumber) {
        return parsedPhoneNumber.formatNational()
    }

    return ''
}
